import { render, staticRenderFns } from "./WidgetHeader.vue?vue&type=template&id=348c0b66"
import script from "./WidgetHeader.vue?vue&type=script&lang=ts"
export * from "./WidgetHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports